<template>
  <select @change="changeEvent($event)" v-bind:class="{ darkMode: darkMode, smallMode: smallMode}">
    <option v-if="!this.selected" disabled selected>{{placeholder}}</option>
    <option v-for="value in options" :key="value.id" :value="value.id" :selected="selected === value.id">{{value.name}}</option>
  </select>
</template>

<script>

export default {
  name: 'dropdown',
  props: {
    options: Array,
    selected: String,
    darkMode: Boolean,
    smallMode: Boolean,
    placeholder: String,
    disabled: Boolean
  },
  methods: {
    changeEvent: function(event){
      this.$emit('changeEvent',event.target.value);
    }
  }
}
</script>

<style scoped>
  select {
    background-color: #333746;
    border: none;
    color: #FFFFFF80;
    font-size: 14px;
  }
  select:not(.smallMode) {
    height: 40px;
    min-width: 200px;
  }
  select.smallMode {
    height: 30px;
  }
  .darkMode {
    background-color: #2E303A;
  }
</style>
